/**
 * valveFeedback — "Let us know" opener shared by the valve member surfaces
 * (status door · valve pop-up · not-found page).
 *
 * Owner design (confirmed 9-11-26): feedback is BY DESIGN open to anyone — no account,
 * no sign-in. Anyone clicking "Let us know" opens the SAME feedback composer the footer
 * Feedback button opens (FeedbackModal, reached via the openReportModal document event
 * handled by the Navbar's instance). The composer handles both sides:
 *   - signed-in user  → submitted as their account (existing /api/user/submit-feedback)
 *   - guest/visitor   → anonymous via the public rate-limited POST /api/guest-report
 *                       (email optional; both become tickets in the admin inbox).
 * Docs: by Function/admin-tools/feedback-design-anonymous-CONFIRMED-9-11-26.md
 */
export const openFeedbackFor = (subject = '') => {
  // NOTE: the report listeners live on document (window does not reach them).
  document.dispatchEvent(
    new CustomEvent('openReportModal', {
      detail: { subject: subject || '', message: '' }
    })
  );
};
